import * as React from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';

export const TbEqualsIcon = () => {
    return (
        <SvgIcon>
            <path d="M20,8.32H4V9.79H20ZM4,15.68H20V14.21H4Z" />
        </SvgIcon>
    );
};
